/**
 * Header Search - Inline animated search bar with custom validation
 */
(function() {
  'use strict';

  const searchForm = document.getElementById('header-search-form');
  const searchInput = document.getElementById('header-search-input');
  const searchToggle = document.getElementById('header-search-toggle');
  const searchFormSubmit = document.getElementById('header-search-form-submit');
  const searchError = document.getElementById('header-search-error');

  if (!searchForm || !searchInput || !searchToggle) {
    return;
  }

  // Toggle search bar on icon click
  searchToggle.addEventListener('click', function(e) {
    e.preventDefault();
    const isActive = searchForm.classList.contains('is-active');
    
    if (isActive) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  // Open search bar
  function openSearch() {
    searchForm.classList.add('is-active');
    setTimeout(function() {
      searchInput.focus();
    }, 150);
  }

  // Close search bar
  function closeSearch() {
    searchForm.classList.remove('is-active');
    searchInput.blur();
    hideError();
  }

  // Show validation error
  function showError() {
    searchError.style.display = 'block';
    searchInput.classList.add('has-error');
    setTimeout(function() {
      hideError();
    }, 3000);
  }

  // Hide validation error
  function hideError() {
    searchError.style.display = 'none';
    searchInput.classList.remove('has-error');
  }

  // Clear error on input
  searchInput.addEventListener('input', function() {
    if (this.value.trim()) {
      hideError();
    }
  });

  // Handle form submission
  searchForm.addEventListener('submit', function(e) {
    if (!searchInput.value.trim()) {
      e.preventDefault();
      showError();
    }
  });

  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (searchForm.classList.contains('is-active') && 
        !searchForm.contains(e.target) && 
        !searchToggle.contains(e.target)) {
      closeSearch();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchForm.classList.contains('is-active')) {
      closeSearch();
    }
  });
})();
